"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStaticChannels = useStaticChannels;
var _react = require("react");
var _streamChatReact = require("stream-chat-react");
var _utils = require("../../../utils");
var _utils2 = require("./utils");
var _reactRouterDom = require("react-router-dom");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function useStaticChannels(baseUrl, setMenuOpen) {
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    pathname = _useLocation.pathname;
  var _useChatContext = (0, _streamChatReact.useChatContext)(),
    channel = _useChatContext.channel,
    setActiveChannel = _useChatContext.setActiveChannel;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    staticChannelId = _useState2[0],
    setStaticChannelId = _useState2[1];
  var channelIdFromPath = (0, _react.useMemo)(function () {
    return (0, _utils2.getChannelIdFromPath)(baseUrl, pathname);
  }, [baseUrl, pathname]);
  var staticChannel = _utils2.staticChannelItems.find(function (item) {
    return item.id === channelIdFromPath;
  });
  (0, _react.useEffect)(function () {
    // We need to check if it is a static channel and set it
    if (staticChannel !== null && staticChannel !== void 0 && staticChannel.id) {
      setStaticChannelId(staticChannel === null || staticChannel === void 0 ? void 0 : staticChannel.id);
      // We also need to discard getstream channel if it set and we're navigating to a static one
      if (channel !== null && channel !== void 0 && channel.id) {
        setActiveChannel();
      }
      // Additionally, we need to close channels list on mobile
      if ((0, _utils.isMobileOrTablet)()) {
        setMenuOpen(false);
      }
    } else {
      // Unset if the channel is not static
      setStaticChannelId();
    }
  }, [channel, staticChannel]);
  return {
    staticChannelId: staticChannelId
  };
}